export const GRAY_SMOOTH = "#d7d7d7";
export const GRAY_SMOOTH_2 = "#999999";
